import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Descriptions, Progress, Row, Tabs, Statistic, Tooltip, Space, Spin } from 'antd';
// import { useSelector } from 'react-redux';
import { BarChartOutlined, LeftOutlined, EditOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'underscore';
import { useNavigate } from 'react-router-dom';

import Main from '../../components/layout/Main';
import BreadcrumbNav from '../../components/layout/BreadcrumbNav';
import Logout from '../../components/Logout';
import { AppDispatch, CombinedStates } from '../../core/types';
import { getSingleSchool } from '../../core/school/schoolApi';
import { getSchoolTypeInfo } from '../../core/utils/helpers';
import SchoolMap from '../../components/SchoolMap';
import SchoolIndicatorsStatistics from '../../components/SchoolIndicatorsStatistics';
import SchoolIndicatorsData from '../../components/SchoolIndicatorsData';
import SchoolIndicatorsCalendar from '../../components/SchoolIndicatorsCalendar/index';
import SchoolExamsData from '../../components/SchoolExamsData';
import UserListingTable from '../../components/UserListingTable';
import SchoolClassrooms from '../../components/SchoolClassrooms';
import SchoolContacts from '../../components/SchoolContacts';
import SchoolBvmSurveys from '../../components/SchoolBvmSurveys';
import SchoolProjects from '../../components/SchoolProjects';
import IndicatorsCompareForSchools from '../../components/IndicatorStatisticsComponents/SchoolCompare/indicatorsCompareForSchools';

import './dashboard.scss';

const { TabPane } = Tabs;

const SchoolDashboard = () => {
    const dispatch = useDispatch<AppDispatch>();
    const toolbar = [{ label: 'Item 1', link: '/abc', iconName: 'home' }];
    const navigation = [{ label: 'Item 1', link: '/abc' }, { label: 'Item 1', link: '/abc' }];
    const navigate = useNavigate();
    const {
        userData,
    } = useSelector((state:CombinedStates) => state.user);

    const {
        singleSchool,
        isFetching,
    } = useSelector((state:CombinedStates) => state.school);

    useEffect(() => {
        if (isEmpty(singleSchool)) {
            dispatch(getSingleSchool({}));
        }
    }, []);

    const handleBackToAdmin = () => {
        navigate('/dashboard');
    };

    const backLink = userData?.role_id !== 5 ? (
        <Button onClick={handleBackToAdmin}>
            <LeftOutlined /> Grįžti į administratoriaus darbalaukį
        </Button>
    ) : false;

    const indicatorStats = {
        filled: 12,
        missing: 88,
    };

    const total = indicatorStats.filled + indicatorStats.missing;
    const percent = total > 0 ? Math.round((indicatorStats.filled / total) * 100) : 0;

    return (
        <Main
            className="dashboard"
            title={<div>Mokyklos darbalaukis</div>}
            headerTitle={<div>Mokyklos {singleSchool?.name} darbalaukis</div>}
            menuWidth={350}
            menuPlacement="left"
            toolbar={toolbar}
            showFooter={false}
            floatingHeader={false}
            footerContent={<div style={{ lineHeight: '30px', fontSize: '16px', float: 'right' }}>&copy; copyright 2020</div>}
            floatingFooter
            backLink={false}
            breadcrumb={null}>
            <Row className="school-dashboard-buttons" justify="space-between" gutter={12}>
                <Col>
                    {userData?.role_id !== 5 && (
                        <Button
                            type="text"
                            icon={<LeftOutlined />}
                            onClick={handleBackToAdmin}>
                            Grįžti atgal
                        </Button>
                    )}
                </Col>
                <Col>
                    <Space>
                        <Tooltip title="Redaguoti mokyklos informaciją">
                            <Button
                                shape="circle"
                                type="primary"
                                icon={<EditOutlined />}
                                onClick={() => navigate('/mokykla/redagavimas')} />
                        </Tooltip>
                    </Space>
                </Col>
            </Row>
            <Card style={{ marginTop: '20px' }}>
                <Tabs defaultActiveKey="1">
                    {/* TAB 1: Mokyklos informacija */}
                    <TabPane tab="Pagrindinė informacija" key="1">
                        <Spin spinning={isFetching}>
                            <Row gutter={16}>
                                <Col span={12} xs={24} sm={24} md={12}>
                                    {/* Buttons */}
                                    <Descriptions title="Mokyklos informacija" bordered column={1} style={{ marginBottom: 24 }}>
                                        <Descriptions.Item label="Pavadinimas">{singleSchool?.name}</Descriptions.Item>
                                        <Descriptions.Item label="Adresas">{singleSchool?.address}</Descriptions.Item>
                                        <Descriptions.Item label="Telefonas">{singleSchool?.phone}</Descriptions.Item>
                                        <Descriptions.Item label="Tipas">{getSchoolTypeInfo(singleSchool?.type || '')?.label || singleSchool?.type}</Descriptions.Item>
                                    </Descriptions>

                                    <Row justify="end" gutter={8}>
                                        <Col>
                                            <Button icon={<EditOutlined />} type="primary" onClick={() => navigate('/mokykla/redagavimas')}>
                                                Redaguoti mokyklos informaciją
                                            </Button>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col span={12}>
                                    <SchoolMap
                                        lat={singleSchool?.latitude || 0}
                                        lng={singleSchool?.longitude || 0}
                                        name={singleSchool?.name}
                                        address={singleSchool?.address}
                                        phone={singleSchool?.phone}
                                        type={singleSchool?.type} />
                                </Col>
                            </Row>
                        </Spin>
                    </TabPane>

                    <TabPane tab="Rodiklių duomenys" key="2">
                        <Tabs defaultActiveKey="3-1" type="card">
                            <TabPane tab="Rodiklių duomenys" key="2-1">
                                <SchoolIndicatorsData />
                            </TabPane>
                            <TabPane tab="Įvesties statistika" key="2-2">
                                <SchoolIndicatorsStatistics />
                            </TabPane>
                            <TabPane tab="Rodiklių kalendorius" key="2-4">
                                <SchoolIndicatorsCalendar />
                            </TabPane>
                            <TabPane tab="Duomenų palyginimas" key="2-3">
                                <IndicatorsCompareForSchools />
                            </TabPane>
                        </Tabs>
                    </TabPane>

                    <TabPane tab="Klasės" key="3">
                        <SchoolClassrooms schoolId={singleSchool?.id || 0} />
                    </TabPane>

                    { (singleSchool?.type === 'gimnazija' || singleSchool?.type === 'kita') && (
                        <TabPane tab="Egzaminai" key="4">
                            <SchoolExamsData />
                        </TabPane>
                    )}

                    <TabPane tab="Vartotojai" key="5">
                        <UserListingTable customFilters={{ school_id: singleSchool?.id }} />
                    </TabPane>

                    <TabPane tab="Kontaktai" key="6">
                        <SchoolContacts />
                    </TabPane>

                    <TabPane tab="BVM" key="7">
                        <SchoolBvmSurveys schoolId={singleSchool?.id || 0} />
                    </TabPane>

                    <TabPane tab="Projektai" key="8">
                        <SchoolProjects schoolId={singleSchool?.id || 0} />
                    </TabPane>
                </Tabs>
            </Card>
        </Main>
    );
};

export default SchoolDashboard;

SchoolDashboard.propTypes = {};
